<template>
  <div>
    <CRow>
      <CCol xl="12" lg="12" md="12" style="margin-top: 20%" v-if="Spinner">
        <div
          class="sk-wave primary"
          color="success"
          style="margin: auto; width: 10%; top: 50% !important"
        >
          <div class="sk-wave-rect"></div>
          <div class="sk-wave-rect"></div>
          <div class="sk-wave-rect"></div>
          <div class="sk-wave-rect"></div>
          <div class="sk-wave-rect"></div>
        </div>
      </CCol>

      <CCol v-else>
        <CCard style="margin-top: 20px">
          <div style="margin: auto; margin-top: 20px">
            <DatePicker
              v-model="value1"
              type="date"
              range
              placeholder="Select date range"
            ></DatePicker>
          </div>

          <CCardBody>
            <h5 style="float: right">TotalUser's: {{ this.totalUser }}</h5>
            <JsonCSV
              color="primary"
              class="btn btn-default mb-2 clr"
              :data="tableData"
              name="User-list.csv"
              dynamicTyping="true,"
            >
              Download CSV (This is a slot)
            </JsonCSV>
            <!-- <button @click="logOut()">Logout</button> -->
            <CDataTable
              :items="tableData"
              :fields="fields"
              column-filter
              table-filter
              items-per-page-select
              :items-per-page="10"
              hover
              sorter
              pagination
            >
            </CDataTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>
<style src="spinkit/spinkit.min.css"></style>
<script>
import { APIService } from "../../apiservice.js";
import Swal from "sweetalert2";
import AppVue from "../../App.vue";
import firebase from "firebase";
import Apexchart from "vue-apexcharts";
const db = firebase.firestore();
import moment from "moment";
import { getStyle, hexToRgba } from "@coreui/utils/src";
import Userchart from "./userchart.vue";
import JsonCSV from "vue-json-csv";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  components: {
    Apexchart,
    Userchart,
    JsonCSV,
    DatePicker,
  },
  name: "AdvancedTables",
  data() {
    return {
      totalUser: 0,
      Spinner: false,
      table1: true,
      table2: false,
      hidechart: false,
      promocodedata: [],
      named: [],
      counted: [],
      tdata: [],
      tooltips: [],
      tokenList: [],
      sortedArr: [],
      repeatarray: [],
      array: [],
      counter: 1,
      series: [],
      chartOptions: {
        chart: {
          width: 380,
          type: "pie",
        },
        plotOptions: {
          pie: {
            startAngle: -90,
            endAngle: 270,
          },
        },
        dataLabels: {
          enabled: false,
        },
        labels: [],
        fill: {
          type: "gradient",
        },
        // legend: {
        //   formatter: function (val, opts) {
        //     return "test" + " - " + opts.w.globals.series[opts.seriesIndex];
        //   },
        // },
        title: {
          text: "User country donut chart",
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      },
      // tableData: tableData.map((item, id) => {
      //   return { ...item, id };
      // }),
      currentItems: [],
      tableData: [],
      tableData2: [],
      fields: [
        {
          label: "Date",
          key: "date",
          sortable: true,
        },
        // {
        //   key: "firstName",
        //   sortable: true,
        // },
        // {
        //   key: "lastName",
        //   sortable: true,
        // },
        {
          key: "email",
          sortable: true,
        },
        // {
        //   label: "Mobile no",
        //   key: "phoneNumber",
        //   sortable: true,
        // },
        {
          key: "ethAddress",
          sortable: true,
          label: "Ethereum Address",
        },

        {
          key: "provider",
          sortable: true,
        },
        // {
        //   key:"email",
        // label: "email",
        // },

        // {
        //   key:"Rage",
        //   label: "Rage",
        // },
        //  {
        //   key:"Matic",
        //   label: "Matic",
        // },
        //  {
        //   key:"Razor",
        //   label: "Razor",
        // },
        // {
        //   key:"Drakoin",
        //   label: "Drakoin",
        // },
        // {
        //   key:"CryptoPuzzles",
        //   label: "CryptoPuzzles",
        // },
        //  {
        //   key:"AxiInfinite",
        //   label: "AxiInfinite",
        // },
        //  {
        //   key:"IndependenceDay",
        //   label: "IndependenceDay",
        // },
        //  {
        //   key:"RageFan_GenShards",
        //   label: "RageFan_GenShards",
        // },
        //   {
        //   key:"circuit_city",
        //   label: "circuit_city",
        // },
        //  {
        //   key:"FinEuro",
        //   label: "FinEuro",
        // },
        //  {
        //   key:"DEADRATNFT",
        //   label: "DEADRATNFT",
        // }
      ],
      value1: [],
      details: [],
      collapseDuration: 0,
      ragedata1: [],
    };
  },
  computed: {
    defaultDatasets() {
      const brandSuccess = getStyle("success") || "#4dbd74";
      const brandInfo = getStyle("info") || "#20a8d8";
      const brandDanger = getStyle("danger") || "#f86c6b";

      let elements = 3;
      const data1 = [];
      const data2 = [];
      var data3 = [];

      for (let i in this.tokenList) {
        // for (let j = 0; j < this.tokenList[i].length; j++) {

        if (this.tokenList[i].name && this.tokenList[i].count) {
          this.chartOptions.labels.push(
            this.tokenList[i].name + " - " + this.tokenList[i].count
          );
          this.series.push(this.tokenList[i].count);
        }
        // }
        this.tooltips.push(this.named);
        this.tdata.push({
          name: i,
          labels: this.named,
          backgroundColor: hexToRgba(brandInfo, 10),
          borderColor: brandInfo,
          pointHoverBackgroundColor: brandInfo,
          borderWidth: 2,
          data: this.counted,
        });
      }
      return this.tdata;
    },
    defaultOptions() {
      return {
        chart: {
          height: 350,
          type: "area",
        },
        // dataLabels: {
        //   enabled: true,
        //   enabledOnSeries: true,
        //   formatter: function (val, opts) {
        //     return "123456789";
        //   },
        // },
        tooltip: {
          custom: function ({ series, seriesIndex, dataPointIndex, w }) {
            let mail =
              w.config.series[seriesIndex].data[dataPointIndex].split("$");
            return (
              '<div class="arrow_box">' +
              "<span>" +
              mail[1] +
              "</span>" +
              "</div>"
            );
          },
        },
        stroke: {
          curve: "smooth",
        },
      };
    },
    csvContent() {
      return this.currentItems
        .map((item) => Object.values(item).join(","))
        .join("\n");
    },
    csvCode() {
      return (
        "data:text/csv;charset=utf-8,SEP=,%0A" +
        encodeURIComponent(this.csvContent)
      );
    },
  },
  watch: {
    tableData() {},
    value1() {
      // let v1 = moment(this.value1[0]).format("DD-MMM-YYYY");
      // let v2 = moment(this.value1[1]).format("DD-MMM-YYYY");
      this.Spinner = true;
      this.tableData = [];

      if (this.value1[0] != null && this.value1[1] != null) {
        var res = new Date(this.value1[1]);
        res.setDate(res.getDate() + 1);

        let v1 = firebase.firestore.Timestamp.fromDate(
          new Date(this.value1[0])
        );
        let v2 = firebase.firestore.Timestamp.fromDate(new Date(res));

        db.collection("users")
          // .where("created", "!=", null)
          .where("created", ">=", v1)
          .where("created", "<=", v2)
          .get()
          .then((snapshot) => {
            snapshot.forEach((doc) => {
              // let emaildata = this.promocodedata.filter((a) => {
              //   return a.puserid == doc.data().promocode;
              // });
              let backenddate = moment(
                doc.data().created.seconds * 1000
              ).format("DD-MMM-YYYY");
              this.tableData.push({
                firstName: doc.data().firstName,
                lastName: doc.data().lastName,
                email: doc.data().email,
                ethAddress: doc.data().ethAddress,
                country: doc.data().country,
                date: backenddate,
                promocode: doc.data().promocode,
                userid: doc.data().userid,
                // Promoemail:
                //   emaildata[0] != undefined ? emaildata[0].pemail : null,
                phoneNumber:
                  doc.data().phoneNumber != undefined
                    ? doc.data().phoneNumber
                    : 0,
                provider: doc.data().provider,
              });

              // }
            });
            this.Spinner = false;
          });
      } else {
        window.location.reload();
      }
    },
  },
  methods: {
    logOut() {
      const auth = firebase.auth();
      auth
        .signOut()
        .then(() => {
          localStorage.clear();
          this.$router.push({ name: "LoginPage" });
          location.reload();
        })
        .catch(function (error) {
          // An error happened
          alert("Error Occured");
        });
    },
    async getuserscount() {
      const userCount = await db.collection("settings").doc("userCount").get();
      this.totalUser = userCount.data().count;
    },
    refresh() {
      window.location.reload();
    },
    formattime(value) {
      return moment(value).format("h:mm:ss A");
    },
    formatDate(value) {
      return moment(value).format("DD. MMM. YYYY");
    },
    setCurrentItems(val) {
      this.currentItems = val;
    },
    toggleDetails(item) {
      this.$set(this.tableData[item.id], "_toggled", !item._toggled);
      this.collapseDuration = 300;
      this.$nextTick(() => {
        this.collapseDuration = 0;
      });
    },
    wizard() {
      this.$router.push({ name: "wizard" });
    },
    editToken(item, index) {
      this.$router.push({ name: "editUser", params: { id: item.id } });
    },
    assignsmallData(doc) {
      let smallDocument = {
        // id: doc.id,
        firstName: doc.data().firstName,
        lastName: doc.data().lastName,
        email: doc.data().email,
        ethAddress: doc.data().ethAddress,
        country: doc.data().country,
        date: moment(doc.data().created).format("DD-MMM-YYYY"),
      };
      return smallDocument;
    },
    getuserlist() {
      this.Spinner = true;
      var startOfToday = new Date();
      startOfToday.setHours(0, 0, 0, 0);
      var endOfToday = new Date();
      endOfToday.setHours(23, 59, 59, 999);

      this.tableData = [];

      db.collection("users")
        .where("created", ">=", startOfToday)
        .where("created", "<=", endOfToday)
        .orderBy("created", "desc")
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            // let tokendata = this.ragedata1.filter((b) => {
            //   return b.id == doc.id;
            // });

            let backenddate =
              doc.data().created != null
                ? moment(doc.data().created.seconds * 1000).format(
                    "DD-MMM-YYYY"
                  )
                : "";

            this.tableData.push({
              firstName: doc.data().firstName,
              lastName: doc.data().lastName,
              email: doc.data().email,
              ethAddress: doc.data().ethAddress,
              country: doc.data().country,
              date: backenddate,
              promocode: doc.data().promocode,
              userid: doc.data().userid,
              // Promoemail:
              //   emaildata[0] != undefined ? emaildata[0].pemail : null,
              phoneNumber:
                doc.data().phoneNumber != undefined
                  ? doc.data().phoneNumber
                  : 0,
              provider: doc.data().provider,
              //   Rage: tokendata[0] != undefined ? tokendata[0].Ragecount : 0,
              //   Matic: tokendata[0] != undefined ? tokendata[0].Maticcount : 0,
              //   Razor: tokendata[0] != undefined ? tokendata[0].Razorcount : 0,
              //   Drakoin:
              //     tokendata[0] != undefined ? tokendata[0].Drakoincount : 0,
              //   CryptoPuzzles:
              //     tokendata[0] != undefined ? tokendata[0].CryptoPuzzles : 0,
              //   AxiInfinite:
              //     tokendata[0] != undefined ? tokendata[0].AxiInfinite : 0,
              //   IndependenceDay:
              //     tokendata[0] != undefined ? tokendata[0].IndependenceDay : 0,
              //   RageFan_GenShards:
              //     tokendata[0] != undefined ? tokendata[0].RageFan_GenShards : 0,
              //   circuit_city:
              //     tokendata[0] != undefined ? tokendata[0].circuit_city : 0,
              //   FinEuro: tokendata[0] != undefined ? tokendata[0].FinEuro : 0,
              // DEADRATNFT: tokendata[0] != undefined ? tokendata[0].DEADRATNFT :0,
            });
          });
          this.Spinner = false;
          // localStorage.setItem("usertable", JSON.stringify(this.tableData));
          let value = this.tableData.map((n) => {
            return n.country;
          });

          this.count(value);
          this.loading = false;
        });
    },
    count(temarray) {
      (this.array = []), (this.repeatarray = []);
      this.sortedArr = temarray.sort();

      for (var i = 0; i < this.sortedArr.length; i = i + this.counter) {
        this.counter = 1;
        for (var j = i + 1; j < this.sortedArr.length; j++) {
          if (this.sortedArr[i] === this.sortedArr[j]) this.counter++;
        }
        this.array.push(this.counter);

        this.repeatarray.push({
          name: this.sortedArr[i],
          count: this.counter,
        });
      }
    },
    getpromolist() {
      this.ragedata1 = [];

      const db = firebase.firestore();

      db.collection("collectedCoins2")
        .get()
        .then((snapshot) => {
          this.ragedata1 = [];
          snapshot.forEach((doc) => {
            this.ragedata1.push({
              id: doc.id,
              Ragecount:
                doc.data().Rage != undefined ? doc.data().Rage.length : 0,
              Maticcount:
                doc.data().Matic != undefined ? doc.data().Matic.length : 0,
              Razorcount:
                doc.data().Razor != undefined ? doc.data().Razor.length : 0,
              Drakoincount:
                doc.data().Drakoin != undefined ? doc.data().Drakoin.length : 0,
              CryptoPuzzles:
                doc.data()["Crypto Puzzles"] != undefined
                  ? doc.data()["Crypto Puzzles"].length
                  : 0,
              IndependenceDay:
                doc.data()["75th Indian Independence Day Edition"] != undefined
                  ? doc.data()["75th Indian Independence Day Edition"].length
                  : 0,
              RageFan_GenShards:
                doc.data()["RageFan+GenShards Partnership NFT"] != undefined
                  ? doc.data()["RageFan+GenShards Partnership NFT"].length
                  : 0,
              circuit_city:
                doc.data()["circuit city"] != undefined
                  ? doc.data()["circuit city"].length
                  : 0,
              FinEuro:
                doc.data()["FinEuro"] != undefined
                  ? doc.data()["FinEuro"].length
                  : 0,
              AxiInfinite:
                doc.data()["Axi Infinite"] != undefined
                  ? doc.data()["Axi Infinite"].length
                  : 0,
              DEADRATNFT:
                doc.data()["DEADRAT_RAGEFAN_SPECIAL EDITION"] != undefined
                  ? doc.data()["DEADRAT_RAGEFAN_SPECIAL EDITION"].length
                  : 0,
            });
          });
        });
    },

    rowClicked(item, index, column, e) {
      this.documentId = item.id;
    },

    deleteRoute(item) {
      this.documentId = item.id;
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          width: "600px",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "No, cancel!",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.value) {
            swalWithBootstrapButtons.fire(
              "Deleted!",
              "Your file has been deleted.",
              "success"
            );
            this.deletecompanyDetails();
          } else if (
            /* Read more about handling dismissals below */
            result.dismiss === Swal.DismissReason.cancel
          ) {
            swalWithBootstrapButtons.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },

    deletecompanyDetails(item) {
      db.collection("companyDetails")
        .doc(this.documentId)
        .delete()
        .then(() => {
          this.gettokens();
        })
        .catch((error) => {
          console.error("Error removing document: ", error);
        });
    },
  },
  created() {
    this.getuserlist();
    this.getuserscount();
    //   this.tableData = JSON.parse(localStorage.getItem("usertable"))
    //    this.tokenList = JSON.parse(localStorage.getItem("grapdata"))
    //     window.setInterval(() => {
    //  this.tableData = JSON.parse(localStorage.getItem("usertable"))
    //    this.tokenList = JSON.parse(localStorage.getItem("grapdata"))
    //      }, 300000);

    // this.getpromolist();
    // this.gettokens();
  },
};
</script>
<style >
.clr {
  color: #fff !important;
  background-color: #321fdb !important;
}
.sk-wave-rect {
  background-color: #4638c2;
  height: 100%;
  width: 15%;
  -webkit-animation: sk-wave 3.2s ease-in-out infinite;
  animation: sk-wave 3.2s ease-in-out infinite;
}
</style>
